<template>
  <div class="reaction-add-tooltip__container">
    <slot></slot>
    <div class="reaction-add-tooltip" v-if="tooltipVisible">
      <div class="reaction-add-tooltip__info">{{ tooltipInfo }}</div>
      <div class="reaction-add-tooltip__content">
        <tooltip-reaction-button
          :key="reactionType"
          :reaction="reaction"
          @click="toggleReaction(reactionType)"
          @mouseleave="clearTooltipInfo"
          @mouseover="setTooltipInfo(reactionType)"
          v-for="(reaction, reactionType) in reactions"
        ></tooltip-reaction-button>
      </div>
    </div>
  </div>
</template>

<script>
import TooltipReactionButton from "./TooltipReactionButton";

export default {
  name: "ReactionAddTooltip",
  components: {
    TooltipReactionButton
  },
  props: ["reactions", "tooltipVisible"],
  data() {
    return {
      currentInformationText: null,
      information: {
        heart: "Love",
        like: "Like",
        laugh: "Laugh",
        frown: "Sad",
        surprise: "Surprise"
      }
    };
  },
  computed: {
    tooltipInfo() {
      return this.currentInformationText || "Add a reaction:";
    }
  },
  methods: {
    toggleReaction(reactionType) {
      this.$emit("toggle", reactionType);
    },
    setTooltipInfo(reactionType) {
      this.currentInformationText = this.information[reactionType];
    },
    clearTooltipInfo() {
      this.currentInformationText = null;
    }
  }
};
</script>
